import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './subscribe-modal.m.css';
import { SUBSCRIPTIONGETMODAL } from '../../../../constants';
import Lottie from "lottie-react";
import LiveIcon from './celebration.json';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../atoms/loader';
import { USER_SUBSCRIBER, USER_SUBSCRIPTION } from '../../../../../store/actions';
import { trackPurchaseSuccess } from '../../../../helpers/datalayer-utils';
import get from 'lodash/get';

const SubscribeModal = ({ isOpen, setOpen, subscription }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));
  const userData = useSelector((state) => get(state, ['userData']));
  if (!isOpen) {
    return null;
  }
  const handleClick = async () => {
    if (subscription?.subscription_type === 'standard' && subscription?.status === 'active') {
      await dispatch({ type: USER_SUBSCRIBER, payload: true });
      await dispatch({
        type: USER_SUBSCRIPTION,
        payload: {
          active: subscription,
          otherSubscription: null,
        },
      });
      setOpen(false);
      setLoading(false);
      trackPurchaseSuccess(pageType, userData);
    } else {
      window.location.reload();
    }
  };

  return (
    <div styleName="modal-overlay">
      <div styleName="modal">
        <div styleName="modal-content">
          <img src="/images/story_top_img.svg" styleName="top-banner" />
          <div styleName="title">
            You're now <br /> a Profit<span> Subscriber</span>
          </div>
          <div styleName="sub-title">ENJOY FULL ACCESS TO</div>
          {SUBSCRIPTIONGETMODAL?.map((list) => (
            <div styleName="heading" key={list.id}>
              <img src={list.icon} width="20px" height="20px" />
              <div dangerouslySetInnerHTML={{ __html: list.name }} styleName="head-name" />
            </div>
          ))}
          <button styleName="btn-wrap" onClick={() => handleClick()}>
            OK, Got It !
            {loading && (
              <Loader
                height="auto"
                loaderSize="small"
                style={{
                  border: '2px solid #ffffff',
                  borderTopColor: 'transparent',
                }}
              />
            )}
          </button>
          <img src="/images/story_bottom_img.svg" styleName="bottom-banner" />
          <div styleName="bottom-banner">
            <Lottie animationData={LiveIcon} loop={true} autoplay={true} />
          </div>
        </div>
      </div>
    </div>
  );
};

SubscribeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

SubscribeModal.defaultProps = {};

export default SubscribeModal;
